// Module
var code = "<page-record-preview-zoomin-directive layout-fill></page-record-preview-zoomin-directive>";
// Exports
module.exports = code;